<template>
	<div class="basic_wrap" style="overflow: hidden;">
		<div class="red_top_bg m-flex m-f-between m-pd1">
            <div class="logos">
                <img :src="logo" alt="">
            </div>
			<div class="img-x" @click="$router.back()">
				<img src="@/views/images/item/clear.png" alt="">
			</div>
		</div>
        <div class="m-pd1">
            <van-cell v-for="item in list" :to="item.path" :key="item.path" size="large" :title="item.label" is-link/>
            <van-cell size="large" :title="$t('safe.signOut')" @click="logout" is-link/>
        </div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	export default {
		data() {
			return {
                logo:localStorage.getItem('logo') || ''
			}
		},
        computed:{
            list(){
                return [
                    /* {label:this.$t('home.item'),path:'/item'},
                    {label:this.$t('home.activity'),path:'/activity'},
                    {label:this.$t('home.my'),path:'/user'}, */
                    // {label:this.$t('index.sign'),path:'/sign'},
                    // {label:this.$t('index.invite'),path:'/myTeam'},
                    {label:this.$t('index.recharge'),path:'/invest'},
                    {label:this.$t('我要提现'),path:'/cash'},
                    // {label:this.$t('index.risk'),path:'/about/8'},
                    {label:this.$t('index.secret'),path:'/about/13'},
                    {label:this.$t('index.agreement'),path:'/about/12'},
                    {label:this.$t('index.aboutUs'),path:'/about/11'},
                    // {label:this.$t('safe.language'),path:'/language'},
                ]
            }
        },
		created() {
		},
		mounted() {
		},
		methods: {
            logout() {
				localStorage.removeItem('token');
				this.$router.replace("/");
			}
		}
	};
</script>

<style lang="less" scoped>
.red_top_bg {
  .logos {
    width: fit-content;
    height: 30px;
    img {
      width: auto;
      height: 100%;
      display: block;
    }
  }
}
</style>
